/**
 * Named constants. No magic numbers anywhere else in the codebase —
 * see CLAUDE.md "Do-not list".
 */

/** Default page size for server-driven tables. */
export const DEFAULT_PAGE_SIZE = 20;

/** Allowed page sizes offered in the table pagination control. */
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100] as const;

/** First page index (TanStack Table is 0-based; we expose 1-based in the URL). */
export const FIRST_PAGE = 1;

/** How long a successful query is considered fresh, in milliseconds. */
export const DEFAULT_STALE_TIME_MS = 30_000;

/** Default retry count for queries. */
export const DEFAULT_QUERY_RETRY = 2;

/** Simulated network latency for MSW handlers, in milliseconds. */
export const MOCK_LATENCY_MS = 350;

/**
 * Default timeout for every API request, in milliseconds. A hung backend fails
 * loudly instead of leaving queries pending forever. Callers that pass their
 * own `AbortSignal` opt out of this default and own cancellation themselves.
 */
export const API_TIMEOUT_MS = 30_000;
